// Generated on 2026-10-02T21:21:46.469Z
// This file contains preloaded vehicles models data from the API
// Do not edit manually - use 'npm run generate:vehicles-models-data' to regenerate

export const preloadedVehiclesModels: any = [
  {
    "marca": "HONDA",
    "modelo": "CR-V",
    "busquedas": "162140"
  },
  {
    "marca": "FORD",
    "modelo": "ESCAPE",
    "busquedas": "157605"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA",
    "busquedas": "142819"
  },
  {
    "marca": "HONDA",
    "modelo": "CIVIC",
    "busquedas": "117190"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA",
    "busquedas": "102305"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TACOMA",
    "busquedas": "48583"
  },
  {
    "marca": "KIA",
    "modelo": "SORENTO",
    "busquedas": "45293"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER",
    "busquedas": "38168"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER",
    "busquedas": "37024"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RAV4",
    "busquedas": "33137"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "L200",
    "busquedas": "30774"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HILUX",
    "busquedas": "30219"
  },
  {
    "marca": "FORD",
    "modelo": "RANGER",
    "busquedas": "27009"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER NP300 D23",
    "busquedas": "21610"
  },
  {
    "marca": "JEEP",
    "modelo": "PATRIOT",
    "busquedas": "20454"
  },
  {
    "marca": "ISUZU",
    "modelo": "D-MAX",
    "busquedas": "20301"
  },
  {
    "marca": "NISSAN",
    "modelo": "SENTRA",
    "busquedas": "17878"
  },
  {
    "marca": "TOYOTA",
    "modelo": "4RUNNER",
    "busquedas": "17802"
  },
  {
    "marca": "FORD",
    "modelo": "FOCUS",
    "busquedas": "17410"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE",
    "busquedas": "16357"
  },
  {
    "marca": "PONTIAC",
    "modelo": "VIBE",
    "busquedas": "14902"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "LANCER",
    "busquedas": "14577"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PICKUP",
    "busquedas": "13958"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER D22",
    "busquedas": "13435"
  },
  {
    "marca": "HONDA",
    "modelo": "FIT",
    "busquedas": "13291"
  },
  {
    "marca": "MAZDA",
    "modelo": "BT-50",
    "busquedas": "12495"
  },
  {
    "marca": "KIA",
    "modelo": "SPORTAGE",
    "busquedas": "12455"
  },
  {
    "marca": "FORD",
    "modelo": "F-150",
    "busquedas": "12399"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ACCENT",
    "busquedas": "11379"
  },
  {
    "marca": "HONDA",
    "modelo": "PILOT",
    "busquedas": "11344"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TUCSON",
    "busquedas": "11145"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "COLORADO",
    "busquedas": "11107"
  },
  {
    "marca": "HONDA",
    "modelo": "ACCORD",
    "busquedas": "10761"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE",
    "busquedas": "10694"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER PRADO",
    "busquedas": "8434"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATHFINDER",
    "busquedas": "8345"
  },
  {
    "marca": "MAZDA",
    "modelo": "3",
    "busquedas": "8085"
  },
  {
    "marca": "JEEP",
    "modelo": "WRANGLER",
    "busquedas": "8014"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MATRIX",
    "busquedas": "7673"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK",
    "busquedas": "7427"
  },
  {
    "marca": "KIA",
    "modelo": "RIO",
    "busquedas": "7001"
  },
  {
    "marca": "TOYOTA",
    "modelo": "YARIS",
    "busquedas": "6424"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER",
    "busquedas": "6364"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HIACE",
    "busquedas": "5996"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO SPORT",
    "busquedas": "5873"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CAMRY",
    "busquedas": "5376"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "AMAROK",
    "busquedas": "5000"
  },
  {
    "marca": "NISSAN",
    "modelo": "ALTIMA",
    "busquedas": "4742"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE SPORT",
    "busquedas": "4716"
  },
  {
    "marca": "HONDA",
    "modelo": "ODYSSEY",
    "busquedas": "4619"
  },
  {
    "marca": "MAZDA",
    "modelo": "TRIBUTE",
    "busquedas": "4471"
  },
  {
    "marca": "KIA",
    "modelo": "SPECTRA",
    "busquedas": "4424"
  },
  {
    "marca": "MAZDA",
    "modelo": "PROTEGE",
    "busquedas": "4368"
  },
  {
    "marca": "NISSAN",
    "modelo": "VERSA",
    "busquedas": "4328"
  },
  {
    "marca": "JEEP",
    "modelo": "COMPASS",
    "busquedas": "4278"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CRUZE",
    "busquedas": "4197"
  },
  {
    "marca": "NISSAN",
    "modelo": "NAVARA D40",
    "busquedas": "4159"
  },
  {
    "marca": "JEEP",
    "modelo": "CHEROKEE",
    "busquedas": "4134"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TERCEL",
    "busquedas": "4086"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "H-100",
    "busquedas": "3919"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER SPORT",
    "busquedas": "3846"
  },
  {
    "marca": "JEEP",
    "modelo": "GRAND CHEROKEE",
    "busquedas": "3812"
  },
  {
    "marca": "BMW",
    "modelo": "X3",
    "busquedas": "3604"
  },
  {
    "marca": "HONDA",
    "modelo": "HR-V",
    "busquedas": "3584"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TUNDRA",
    "busquedas": "3481"
  },
  {
    "marca": "KIA",
    "modelo": "PICANTO",
    "busquedas": "3028"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HIGHLANDER",
    "busquedas": "2964"
  },
  {
    "marca": "ISUZU",
    "modelo": "RODEO",
    "busquedas": "2953"
  },
  {
    "marca": "FORD",
    "modelo": "EDGE",
    "busquedas": "2950"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIRAGE",
    "busquedas": "2948"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SIENNA",
    "busquedas": "2876"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAX",
    "busquedas": "2871"
  },
  {
    "marca": "MAZDA",
    "modelo": "6",
    "busquedas": "2795"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO",
    "busquedas": "2791"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TAHOE",
    "busquedas": "2755"
  },
  {
    "marca": "KIA",
    "modelo": "SOUL",
    "busquedas": "2741"
  },
  {
    "marca": "NISSAN",
    "modelo": "XTERRA",
    "busquedas": "2702"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2900",
    "busquedas": "2575"
  },
  {
    "marca": "NISSAN",
    "modelo": "D21",
    "busquedas": "2524"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "NATIVA",
    "busquedas": "2436"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVEO",
    "busquedas": "2427"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRAND STAREX",
    "busquedas": "2421"
  },
  {
    "marca": "FORD",
    "modelo": "EXPEDITION",
    "busquedas": "2418"
  },
  {
    "marca": "HONDA",
    "modelo": "ELEMENT",
    "busquedas": "2402"
  },
  {
    "marca": "KIA",
    "modelo": "SEPHIA",
    "busquedas": "2280"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "S10",
    "busquedas": "2252"
  },
  {
    "marca": "NISSAN",
    "modelo": "QASHQAI",
    "busquedas": "2239"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER",
    "busquedas": "2183"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "GALANT",
    "busquedas": "2147"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2500",
    "busquedas": "2125"
  },
  {
    "marca": "BMW",
    "modelo": "X5",
    "busquedas": "2120"
  },
  {
    "marca": "NISSAN",
    "modelo": "PICKUP",
    "busquedas": "2108"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500",
    "busquedas": "2014"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER",
    "busquedas": "1978"
  },
  {
    "marca": "DODGE",
    "modelo": "NEON",
    "busquedas": "1966"
  },
  {
    "marca": "ISUZU",
    "modelo": "PICKUP KB",
    "busquedas": "1879"
  },
  {
    "marca": "NISSAN",
    "modelo": "URVAN",
    "busquedas": "1829"
  },
  {
    "marca": "FORD",
    "modelo": "MUSTANG",
    "busquedas": "1719"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SONATA",
    "busquedas": "1718"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EQUINOX",
    "busquedas": "1677"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATROL",
    "busquedas": "1657"
  },
  {
    "marca": "NISSAN",
    "modelo": "X-TRAIL",
    "busquedas": "1626"
  },
  {
    "marca": "SUZUKI",
    "modelo": "GRAND VITARA",
    "busquedas": "1620"
  },
  {
    "marca": "BMW",
    "modelo": "328I",
    "busquedas": "1567"
  },
  {
    "marca": "NISSAN",
    "modelo": "MURANO",
    "busquedas": "1345"
  },
  {
    "marca": "HONDA",
    "modelo": "RIDGELINE",
    "busquedas": "1338"
  },
  {
    "marca": "RAM",
    "modelo": "1500",
    "busquedas": "1313"
  },
  {
    "marca": "FORD",
    "modelo": "F-250 SUPER DUTY",
    "busquedas": "1294"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRACKER",
    "busquedas": "1281"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "EON",
    "busquedas": "1279"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "JETTA",
    "busquedas": "1248"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-7",
    "busquedas": "1245"
  },
  {
    "marca": "JEEP",
    "modelo": "LIBERTY",
    "busquedas": "1231"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2200",
    "busquedas": "1227"
  },
  {
    "marca": "NISSAN",
    "modelo": "URVAN NV350",
    "busquedas": "1152"
  },
  {
    "marca": "MERCURY",
    "modelo": "MARINER",
    "busquedas": "1147"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 2500",
    "busquedas": "1112"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 1500",
    "busquedas": "1092"
  },
  {
    "marca": "MAZDA",
    "modelo": "323",
    "busquedas": "1065"
  },
  {
    "marca": "MAZDA",
    "modelo": "626",
    "busquedas": "1041"
  },
  {
    "marca": "NISSAN",
    "modelo": "KICKS",
    "busquedas": "1036"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ECLIPSE",
    "busquedas": "1030"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "I10",
    "busquedas": "1028"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SONIC",
    "busquedas": "1022"
  },
  {
    "marca": "FORD",
    "modelo": "ESCORT",
    "busquedas": "981"
  },
  {
    "marca": "TOYOTA",
    "modelo": "ECHO",
    "busquedas": "981"
  },
  {
    "marca": "DODGE",
    "modelo": "DAKOTA",
    "busquedas": "957"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER SPORT TRAC",
    "busquedas": "953"
  },
  {
    "marca": "FORD",
    "modelo": "FIESTA",
    "busquedas": "918"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-5",
    "busquedas": "887"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "H-1",
    "busquedas": "877"
  },
  {
    "marca": "GMC",
    "modelo": "CANYON",
    "busquedas": "860"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV200",
    "busquedas": "839"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "L300",
    "busquedas": "805"
  },
  {
    "marca": "SUZUKI",
    "modelo": "ESTEEM",
    "busquedas": "796"
  },
  {
    "marca": "DODGE",
    "modelo": "CARAVAN",
    "busquedas": "787"
  },
  {
    "marca": "MAZDA",
    "modelo": "BT-50 PRO",
    "busquedas": "785"
  },
  {
    "marca": "NISSAN",
    "modelo": "TIIDA",
    "busquedas": "783"
  },
  {
    "marca": "JEEP",
    "modelo": "RENEGADE",
    "busquedas": "769"
  },
  {
    "marca": "SUZUKI",
    "modelo": "VITARA",
    "busquedas": "756"
  },
  {
    "marca": "SCION",
    "modelo": "XB",
    "busquedas": "755"
  },
  {
    "marca": "NISSAN",
    "modelo": "JUKE",
    "busquedas": "753"
  },
  {
    "marca": "SCION",
    "modelo": "XA",
    "busquedas": "732"
  },
  {
    "marca": "MAZDA",
    "modelo": "2",
    "busquedas": "725"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRAND I10",
    "busquedas": "721"
  },
  {
    "marca": "SUBARU",
    "modelo": "FORESTER",
    "busquedas": "696"
  },
  {
    "marca": "KIA",
    "modelo": "OPTIMA",
    "busquedas": "661"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TIGUAN",
    "busquedas": "654"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CELICA",
    "busquedas": "649"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "PRIZM",
    "busquedas": "647"
  },
  {
    "marca": "ACURA",
    "modelo": "MDX",
    "busquedas": "638"
  },
  {
    "marca": "SUBARU",
    "modelo": "IMPREZA",
    "busquedas": "638"
  },
  {
    "marca": "BMW",
    "modelo": "325I",
    "busquedas": "635"
  },
  {
    "marca": "NISSAN",
    "modelo": "TITAN",
    "busquedas": "628"
  },
  {
    "marca": "RAM",
    "modelo": "2500",
    "busquedas": "626"
  },
  {
    "marca": "ACURA",
    "modelo": "RDX",
    "busquedas": "618"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ENDEAVOR",
    "busquedas": "615"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT CONNECT",
    "busquedas": "610"
  },
  {
    "marca": "ISUZU",
    "modelo": "PICKUP",
    "busquedas": "606"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TIBURON",
    "busquedas": "599"
  },
  {
    "marca": "DODGE",
    "modelo": "GRAND CARAVAN",
    "busquedas": "574"
  },
  {
    "marca": "SUZUKI",
    "modelo": "AERIO",
    "busquedas": "568"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAPTIVA",
    "busquedas": "558"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2300",
    "busquedas": "554"
  },
  {
    "marca": "SUZUKI",
    "modelo": "FORENZA",
    "busquedas": "547"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SWIFT",
    "busquedas": "540"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVALANCHE",
    "busquedas": "535"
  },
  {
    "marca": "SCION",
    "modelo": "XD",
    "busquedas": "533"
  },
  {
    "marca": "FORD",
    "modelo": "FUSION",
    "busquedas": "527"
  },
  {
    "marca": "ACURA",
    "modelo": "TSX",
    "busquedas": "526"
  },
  {
    "marca": "SCION",
    "modelo": "TC",
    "busquedas": "524"
  },
  {
    "marca": "NISSAN",
    "modelo": "350Z",
    "busquedas": "519"
  },
  {
    "marca": "HUMMER",
    "modelo": "H3",
    "busquedas": "507"
  },
  {
    "marca": "SUZUKI",
    "modelo": "APV",
    "busquedas": "507"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE",
    "busquedas": "495"
  },
  {
    "marca": "BMW",
    "modelo": "Z4",
    "busquedas": "463"
  },
  {
    "marca": "FORD",
    "modelo": "F-350 SUPER DUTY",
    "busquedas": "457"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAMARO",
    "busquedas": "452"
  },
  {
    "marca": "NISSAN",
    "modelo": "720",
    "busquedas": "445"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "CRETA",
    "busquedas": "433"
  },
  {
    "marca": "FORD",
    "modelo": "ECOSPORT",
    "busquedas": "427"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SX4",
    "busquedas": "426"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SEQUOIA",
    "busquedas": "424"
  },
  {
    "marca": "TOYOTA",
    "modelo": "FORTUNER",
    "busquedas": "424"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX470",
    "busquedas": "422"
  },
  {
    "marca": "SUBARU",
    "modelo": "OUTBACK",
    "busquedas": "421"
  },
  {
    "marca": "NISSAN",
    "modelo": "NP300",
    "busquedas": "418"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 3500",
    "busquedas": "414"
  },
  {
    "marca": "ISUZU",
    "modelo": "TROOPER",
    "busquedas": "408"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TERRACAN",
    "busquedas": "400"
  },
  {
    "marca": "ACURA",
    "modelo": "RSX",
    "busquedas": "392"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SIDEKICK",
    "busquedas": "389"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VELOSTER",
    "busquedas": "387"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN",
    "busquedas": "386"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-9",
    "busquedas": "379"
  },
  {
    "marca": "SUZUKI",
    "modelo": "ALTO",
    "busquedas": "375"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAVALIER",
    "busquedas": "374"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 1500",
    "busquedas": "369"
  },
  {
    "marca": "MAZDA",
    "modelo": "5",
    "busquedas": "366"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "METRO",
    "busquedas": "361"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "BLAZER",
    "busquedas": "356"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2000",
    "busquedas": "350"
  },
  {
    "marca": "SUZUKI",
    "modelo": "JIMNY",
    "busquedas": "349"
  },
  {
    "marca": "DODGE",
    "modelo": "JOURNEY",
    "busquedas": "341"
  },
  {
    "marca": "DODGE",
    "modelo": "CALIBER",
    "busquedas": "335"
  },
  {
    "marca": "BMW",
    "modelo": "X1",
    "busquedas": "333"
  },
  {
    "marca": "SATURN",
    "modelo": "VUE",
    "busquedas": "332"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "N300",
    "busquedas": "327"
  },
  {
    "marca": "TOYOTA",
    "modelo": "FJ CRUISER",
    "busquedas": "325"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX470",
    "busquedas": "317"
  },
  {
    "marca": "SUBARU",
    "modelo": "LEGACY",
    "busquedas": "317"
  },
  {
    "marca": "NISSAN",
    "modelo": "MAXIMA",
    "busquedas": "311"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MALIBU",
    "busquedas": "310"
  },
  {
    "marca": "ACURA",
    "modelo": "TL",
    "busquedas": "301"
  },
  {
    "marca": "TOYOTA",
    "modelo": "T100",
    "busquedas": "298"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "PASSAT",
    "busquedas": "298"
  },
  {
    "marca": "DODGE",
    "modelo": "DURANGO",
    "busquedas": "292"
  },
  {
    "marca": "JEEP",
    "modelo": "GLADIATOR",
    "busquedas": "279"
  },
  {
    "marca": "MAZDA",
    "modelo": "MPV",
    "busquedas": "277"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-290",
    "busquedas": "276"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500 HD",
    "busquedas": "274"
  },
  {
    "marca": "GMC",
    "modelo": "ACADIA",
    "busquedas": "272"
  },
  {
    "marca": "DODGE",
    "modelo": "DART",
    "busquedas": "272"
  },
  {
    "marca": "VOLVO",
    "modelo": "S60",
    "busquedas": "269"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAVERSE",
    "busquedas": "263"
  },
  {
    "marca": "NISSAN",
    "modelo": "ARMADA",
    "busquedas": "261"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 1500",
    "busquedas": "261"
  },
  {
    "marca": "KIA",
    "modelo": "SEDONA",
    "busquedas": "254"
  },
  {
    "marca": "ISUZU",
    "modelo": "MU-X",
    "busquedas": "253"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VERACRUZ",
    "busquedas": "252"
  },
  {
    "marca": "VOLVO",
    "modelo": "S40",
    "busquedas": "249"
  },
  {
    "marca": "BMW",
    "modelo": "528I",
    "busquedas": "239"
  },
  {
    "marca": "NISSAN",
    "modelo": "ALMERA",
    "busquedas": "239"
  },
  {
    "marca": "DODGE",
    "modelo": "CHALLENGER",
    "busquedas": "238"
  },
  {
    "marca": "MAZDA",
    "modelo": "B3000",
    "busquedas": "238"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC90",
    "busquedas": "236"
  },
  {
    "marca": "BMW",
    "modelo": "335I",
    "busquedas": "236"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAPTIVA SPORT",
    "busquedas": "235"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA GT",
    "busquedas": "234"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ASX",
    "busquedas": "231"
  },
  {
    "marca": "MAZDA",
    "modelo": "PROTEGE5",
    "busquedas": "230"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER PICKUP",
    "busquedas": "229"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX300",
    "busquedas": "227"
  },
  {
    "marca": "PORSCHE",
    "modelo": "CAYENNE",
    "busquedas": "223"
  },
  {
    "marca": "NISSAN",
    "modelo": "QUEST",
    "busquedas": "217"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER COUNTRYMAN",
    "busquedas": "213"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PT CRUISER",
    "busquedas": "212"
  },
  {
    "marca": "ACURA",
    "modelo": "INTEGRA",
    "busquedas": "210"
  },
  {
    "marca": "GEO",
    "modelo": "PRIZM",
    "busquedas": "206"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SAMURAI",
    "busquedas": "205"
  },
  {
    "marca": "AUDI",
    "modelo": "A4",
    "busquedas": "204"
  },
  {
    "marca": "AUDI",
    "modelo": "Q7",
    "busquedas": "196"
  },
  {
    "marca": "BMW",
    "modelo": "X6",
    "busquedas": "194"
  },
  {
    "marca": "SUZUKI",
    "modelo": "XL-7",
    "busquedas": "193"
  },
  {
    "marca": "MAZDA",
    "modelo": "B4000",
    "busquedas": "187"
  },
  {
    "marca": "LINCOLN",
    "modelo": "NAVIGATOR",
    "busquedas": "184"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "COBALT",
    "busquedas": "183"
  },
  {
    "marca": "ACURA",
    "modelo": "ILX",
    "busquedas": "180"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "N400",
    "busquedas": "180"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "TOWN & COUNTRY",
    "busquedas": "168"
  },
  {
    "marca": "FORD",
    "modelo": "TAURUS",
    "busquedas": "167"
  },
  {
    "marca": "AUDI",
    "modelo": "Q5",
    "busquedas": "163"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAILBLAZER",
    "busquedas": "162"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS",
    "busquedas": "162"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TOUAREG",
    "busquedas": "158"
  },
  {
    "marca": "ISUZU",
    "modelo": "HOMBRE",
    "busquedas": "157"
  },
  {
    "marca": "GMC",
    "modelo": "SONOMA",
    "busquedas": "156"
  },
  {
    "marca": "FORD",
    "modelo": "F-250",
    "busquedas": "156"
  },
  {
    "marca": "BMW",
    "modelo": "328I XDRIVE",
    "busquedas": "153"
  },
  {
    "marca": "HONDA",
    "modelo": "PASSPORT",
    "busquedas": "146"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2600",
    "busquedas": "143"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "BEETLE",
    "busquedas": "143"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C230",
    "busquedas": "143"
  },
  {
    "marca": "CADILLAC",
    "modelo": "ESCALADE",
    "busquedas": "142"
  },
  {
    "marca": "BMW",
    "modelo": "128I",
    "busquedas": "141"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ATOS",
    "busquedas": "141"
  },
  {
    "marca": "BMW",
    "modelo": "330I",
    "busquedas": "139"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "STAREX",
    "busquedas": "138"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIRAGE G4",
    "busquedas": "134"
  },
  {
    "marca": "GEO",
    "modelo": "METRO",
    "busquedas": "133"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "VENTURE",
    "busquedas": "133"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE SPORT",
    "busquedas": "132"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C300",
    "busquedas": "130"
  },
  {
    "marca": "FIAT",
    "modelo": "500",
    "busquedas": "129"
  },
  {
    "marca": "BMW",
    "modelo": "330CI",
    "busquedas": "128"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIGHTY MAX",
    "busquedas": "127"
  },
  {
    "marca": "RAM",
    "modelo": "3500",
    "busquedas": "126"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOLF",
    "busquedas": "124"
  },
  {
    "marca": "DODGE",
    "modelo": "NITRO",
    "busquedas": "123"
  },
  {
    "marca": "GMC",
    "modelo": "TERRAIN",
    "busquedas": "123"
  },
  {
    "marca": "BMW",
    "modelo": "320I",
    "busquedas": "119"
  },
  {
    "marca": "SUZUKI",
    "modelo": "EQUATOR",
    "busquedas": "117"
  },
  {
    "marca": "KIA",
    "modelo": "PREGIO",
    "busquedas": "115"
  },
  {
    "marca": "TOYOTA",
    "modelo": "VENZA",
    "busquedas": "115"
  },
  {
    "marca": "SUZUKI",
    "modelo": "RENO",
    "busquedas": "115"
  },
  {
    "marca": "SUBARU",
    "modelo": "BAJA",
    "busquedas": "114"
  },
  {
    "marca": "FORD",
    "modelo": "WINDSTAR",
    "busquedas": "114"
  },
  {
    "marca": "BMW",
    "modelo": "323I",
    "busquedas": "113"
  },
  {
    "marca": "KIA",
    "modelo": "SPECTRA5",
    "busquedas": "112"
  },
  {
    "marca": "BMW",
    "modelo": "325CI",
    "busquedas": "109"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "MATRIX",
    "busquedas": "108"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVALANCHE 1500",
    "busquedas": "108"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CITY EXPRESS",
    "busquedas": "107"
  },
  {
    "marca": "DODGE",
    "modelo": "CHARGER",
    "busquedas": "106"
  },
  {
    "marca": "BMW",
    "modelo": "318I",
    "busquedas": "106"
  },
  {
    "marca": "HONDA",
    "modelo": "CITY",
    "busquedas": "103"
  },
  {
    "marca": "SUZUKI",
    "modelo": "CELERIO",
    "busquedas": "103"
  },
  {
    "marca": "DAIHATSU",
    "modelo": "TERIOS",
    "busquedas": "103"
  },
  {
    "marca": "BMW",
    "modelo": "535I",
    "busquedas": "102"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 SUPER DUTY",
    "busquedas": "100"
  },
  {
    "marca": "NISSAN",
    "modelo": "VERSA NOTE",
    "busquedas": "100"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "RAIDER",
    "busquedas": "99"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX460",
    "busquedas": "98"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS250",
    "busquedas": "97"
  },
  {
    "marca": "DODGE",
    "modelo": "AVENGER",
    "busquedas": "97"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML350",
    "busquedas": "97"
  },
  {
    "marca": "GEO",
    "modelo": "TRACKER",
    "busquedas": "96"
  },
  {
    "marca": "GMC",
    "modelo": "YUKON",
    "busquedas": "95"
  },
  {
    "marca": "HUMMER",
    "modelo": "H2",
    "busquedas": "95"
  },
  {
    "marca": "BMW",
    "modelo": "325XI",
    "busquedas": "95"
  },
  {
    "marca": "FORD",
    "modelo": "EVEREST",
    "busquedas": "94"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GTI",
    "busquedas": "94"
  },
  {
    "marca": "FORD",
    "modelo": "EXCURSION",
    "busquedas": "93"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AVALON",
    "busquedas": "92"
  },
  {
    "marca": "HONDA",
    "modelo": "CROSSTOUR",
    "busquedas": "92"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX60",
    "busquedas": "91"
  },
  {
    "marca": "BMW",
    "modelo": "525I",
    "busquedas": "91"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "200",
    "busquedas": "88"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E320",
    "busquedas": "87"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX4",
    "busquedas": "87"
  },
  {
    "marca": "KIA",
    "modelo": "CERATO",
    "busquedas": "87"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C250",
    "busquedas": "86"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV350 URVAN",
    "busquedas": "86"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 2500 HD",
    "busquedas": "85"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX330",
    "busquedas": "82"
  },
  {
    "marca": "INFINITI",
    "modelo": "FX35",
    "busquedas": "82"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CRUZE LIMITED",
    "busquedas": "81"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VENUE",
    "busquedas": "81"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "HHR",
    "busquedas": "81"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA COUPE",
    "busquedas": "80"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "OPTRA",
    "busquedas": "79"
  },
  {
    "marca": "GMC",
    "modelo": "ENVOY",
    "busquedas": "78"
  },
  {
    "marca": "KIA",
    "modelo": "SELTOS",
    "busquedas": "78"
  },
  {
    "marca": "ISUZU",
    "modelo": "RODEO SPORT",
    "busquedas": "76"
  },
  {
    "marca": "TOYOTA",
    "modelo": "URBAN CRUISER",
    "busquedas": "74"
  },
  {
    "marca": "KIA",
    "modelo": "RIO5",
    "busquedas": "73"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CRESSIDA",
    "busquedas": "73"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO SPORT",
    "busquedas": "72"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AVENSIS",
    "busquedas": "72"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS300",
    "busquedas": "72"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "EXCEL",
    "busquedas": "71"
  },
  {
    "marca": "KIA",
    "modelo": "RONDO",
    "busquedas": "70"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "SEBRING",
    "busquedas": "70"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-280",
    "busquedas": "70"
  },
  {
    "marca": "TOYOTA",
    "modelo": "YARIS IA",
    "busquedas": "70"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "BEAT",
    "busquedas": "69"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-250",
    "busquedas": "69"
  },
  {
    "marca": "AUDI",
    "modelo": "TT",
    "busquedas": "69"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRACE",
    "busquedas": "67"
  },
  {
    "marca": "ISUZU",
    "modelo": "AMIGO",
    "busquedas": "67"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER",
    "busquedas": "66"
  },
  {
    "marca": "BMW",
    "modelo": "530I",
    "busquedas": "66"
  },
  {
    "marca": "PONTIAC",
    "modelo": "SOLSTICE",
    "busquedas": "66"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX350",
    "busquedas": "65"
  },
  {
    "marca": "JEEP",
    "modelo": "COMMANDER",
    "busquedas": "65"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GENESIS COUPE",
    "busquedas": "63"
  },
  {
    "marca": "CADILLAC",
    "modelo": "SRX",
    "busquedas": "62"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX80",
    "busquedas": "62"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 3500",
    "busquedas": "61"
  },
  {
    "marca": "JAGUAR",
    "modelo": "X-TYPE",
    "busquedas": "60"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ENTOURAGE",
    "busquedas": "60"
  },
  {
    "marca": "NISSAN",
    "modelo": "CUBE",
    "busquedas": "60"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL450",
    "busquedas": "59"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DISCOVERY",
    "busquedas": "59"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKX",
    "busquedas": "57"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "ATLAS",
    "busquedas": "57"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GETZ",
    "busquedas": "57"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TAOS",
    "busquedas": "57"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COASTER",
    "busquedas": "56"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO",
    "busquedas": "55"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER SPORT",
    "busquedas": "55"
  },
  {
    "marca": "BMW",
    "modelo": "X4",
    "busquedas": "54"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500",
    "busquedas": "54"
  },
  {
    "marca": "BMW",
    "modelo": "Z3",
    "busquedas": "53"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "GROOVE",
    "busquedas": "53"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "300",
    "busquedas": "53"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PACIFICA",
    "busquedas": "52"
  },
  {
    "marca": "LEXUS",
    "modelo": "ES300",
    "busquedas": "52"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER SPORT",
    "busquedas": "52"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-3",
    "busquedas": "52"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G6",
    "busquedas": "52"
  },
  {
    "marca": "PONTIAC",
    "modelo": "TORRENT",
    "busquedas": "51"
  },
  {
    "marca": "NISSAN",
    "modelo": "240SX",
    "busquedas": "51"
  },
  {
    "marca": "BMW",
    "modelo": "323CI",
    "busquedas": "51"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ECLIPSE CROSS",
    "busquedas": "50"
  },
  {
    "marca": "BMW",
    "modelo": "135I",
    "busquedas": "49"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "IMPALA",
    "busquedas": "49"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "I20",
    "busquedas": "49"
  },
  {
    "marca": "PONTIAC",
    "modelo": "SUNFIRE",
    "busquedas": "48"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "R350",
    "busquedas": "48"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-350",
    "busquedas": "48"
  },
  {
    "marca": "MAZDA",
    "modelo": "MIATA",
    "busquedas": "47"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 1500",
    "busquedas": "46"
  },
  {
    "marca": "DAIHATSU",
    "modelo": "SIRION",
    "busquedas": "46"
  },
  {
    "marca": "FORD",
    "modelo": "E-150",
    "busquedas": "46"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC60",
    "busquedas": "45"
  },
  {
    "marca": "TOYOTA",
    "modelo": "STARLET",
    "busquedas": "44"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-MARK",
    "busquedas": "44"
  },
  {
    "marca": "VOLVO",
    "modelo": "S80",
    "busquedas": "44"
  },
  {
    "marca": "HONDA",
    "modelo": "CR-Z",
    "busquedas": "43"
  },
  {
    "marca": "BMW",
    "modelo": "328XI",
    "busquedas": "43"
  },
  {
    "marca": "BUICK",
    "modelo": "ENCORE",
    "busquedas": "43"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C240",
    "busquedas": "43"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC70",
    "busquedas": "42"
  },
  {
    "marca": "DODGE",
    "modelo": "STRATUS",
    "busquedas": "41"
  },
  {
    "marca": "SUZUKI",
    "modelo": "S-PRESSO",
    "busquedas": "40"
  },
  {
    "marca": "SCION",
    "modelo": "IQ",
    "busquedas": "40"
  },
  {
    "marca": "MERCURY",
    "modelo": "TRACER",
    "busquedas": "40"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-150",
    "busquedas": "39"
  },
  {
    "marca": "LINCOLN",
    "modelo": "AVIATOR",
    "busquedas": "39"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SUPRA",
    "busquedas": "39"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RUSH",
    "busquedas": "39"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E350",
    "busquedas": "39"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "NEON",
    "busquedas": "39"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PREVIA",
    "busquedas": "39"
  },
  {
    "marca": "NISSAN",
    "modelo": "PULSAR",
    "busquedas": "39"
  },
  {
    "marca": "HONDA",
    "modelo": "S2000",
    "busquedas": "39"
  },
  {
    "marca": "JMC",
    "modelo": "VIGUS",
    "busquedas": "39"
  },
  {
    "marca": "HONDA",
    "modelo": "INSIGHT",
    "busquedas": "39"
  },
  {
    "marca": "HONDA",
    "modelo": "PRELUDE",
    "busquedas": "39"
  },
  {
    "marca": "NISSAN",
    "modelo": "NP300 FRONTIER",
    "busquedas": "39"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "PALISADE",
    "busquedas": "39"
  },
  {
    "marca": "NISSAN",
    "modelo": "TITAN XD",
    "busquedas": "38"
  },
  {
    "marca": "INFINITI",
    "modelo": "G37",
    "busquedas": "38"
  },
  {
    "marca": "BMW",
    "modelo": "330XI",
    "busquedas": "38"
  },
  {
    "marca": "GMC",
    "modelo": "YUKON XL 1500",
    "busquedas": "38"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE SELECT",
    "busquedas": "38"
  },
  {
    "marca": "FORD",
    "modelo": "CONTOUR",
    "busquedas": "37"
  },
  {
    "marca": "DAEWOO",
    "modelo": "LANOS",
    "busquedas": "37"
  },
  {
    "marca": "FORD",
    "modelo": "FLEX",
    "busquedas": "37"
  },
  {
    "marca": "CADILLAC",
    "modelo": "CTS",
    "busquedas": "37"
  },
  {
    "marca": "INFINITI",
    "modelo": "G35",
    "busquedas": "36"
  },
  {
    "marca": "SATURN",
    "modelo": "SL",
    "busquedas": "36"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CMV",
    "busquedas": "36"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 3500 VAN",
    "busquedas": "36"
  },
  {
    "marca": "AUDI",
    "modelo": "S4",
    "busquedas": "36"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML320",
    "busquedas": "36"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA CROSS",
    "busquedas": "35"
  },
  {
    "marca": "SATURN",
    "modelo": "SL1",
    "busquedas": "35"
  },
  {
    "marca": "VOLVO",
    "modelo": "V70",
    "busquedas": "35"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER II",
    "busquedas": "34"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 2500",
    "busquedas": "34"
  },
  {
    "marca": "SUZUKI",
    "modelo": "CARRY",
    "busquedas": "34"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "FREELANDER",
    "busquedas": "34"
  },
  {
    "marca": "SATURN",
    "modelo": "SL2",
    "busquedas": "34"
  },
  {
    "marca": "HONDA",
    "modelo": "CIVIC DEL SOL",
    "busquedas": "33"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "3000GT",
    "busquedas": "33"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO IO",
    "busquedas": "33"
  },
  {
    "marca": "LEXUS",
    "modelo": "ES330",
    "busquedas": "33"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C320",
    "busquedas": "32"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 50",
    "busquedas": "32"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA IM",
    "busquedas": "31"
  },
  {
    "marca": "FORD",
    "modelo": "F-350",
    "busquedas": "31"
  },
  {
    "marca": "SATURN",
    "modelo": "ION",
    "busquedas": "31"
  },
  {
    "marca": "NISSAN",
    "modelo": "MARCH",
    "busquedas": "30"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER EVOQUE",
    "busquedas": "30"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 2500",
    "busquedas": "30"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLK350",
    "busquedas": "30"
  },
  {
    "marca": "KIA",
    "modelo": "CARENS",
    "busquedas": "30"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORVETTE",
    "busquedas": "30"
  },
  {
    "marca": "KIA",
    "modelo": "SONET",
    "busquedas": "29"
  },
  {
    "marca": "FORD",
    "modelo": "E-250",
    "busquedas": "29"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CC",
    "busquedas": "29"
  },
  {
    "marca": "TOYOTA",
    "modelo": "VAN",
    "busquedas": "28"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G5",
    "busquedas": "28"
  },
  {
    "marca": "KIA",
    "modelo": "SOLUTO",
    "busquedas": "28"
  },
  {
    "marca": "NISSAN",
    "modelo": "370Z",
    "busquedas": "26"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 3500 HD",
    "busquedas": "26"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 3500",
    "busquedas": "26"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SOLARA",
    "busquedas": "26"
  },
  {
    "marca": "KIA",
    "modelo": "TELLURIDE",
    "busquedas": "26"
  },
  {
    "marca": "FORD",
    "modelo": "POLICE INTERCEPTOR UTILITY",
    "busquedas": "26"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX570",
    "busquedas": "26"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER PACEMAN",
    "busquedas": "26"
  },
  {
    "marca": "KIA",
    "modelo": "BORREGO",
    "busquedas": "26"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "E-COUNTY",
    "busquedas": "26"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "VOYAGER",
    "busquedas": "25"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 LTD",
    "busquedas": "25"
  },
  {
    "marca": "BUICK",
    "modelo": "ENCLAVE",
    "busquedas": "25"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX56",
    "busquedas": "25"
  },
  {
    "marca": "MAHINDRA",
    "modelo": "SCORPIO",
    "busquedas": "24"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "POLO",
    "busquedas": "24"
  },
  {
    "marca": "PORSCHE",
    "modelo": "BOXSTER",
    "busquedas": "24"
  },
  {
    "marca": "RAM",
    "modelo": "700",
    "busquedas": "24"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK250",
    "busquedas": "24"
  },
  {
    "marca": "SUBARU",
    "modelo": "XV CROSSTREK",
    "busquedas": "24"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKS",
    "busquedas": "24"
  },
  {
    "marca": "ACURA",
    "modelo": "TLX",
    "busquedas": "24"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 2500",
    "busquedas": "24"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-30",
    "busquedas": "24"
  },
  {
    "marca": "MERCURY",
    "modelo": "MOUNTAINEER",
    "busquedas": "23"
  },
  {
    "marca": "SCION",
    "modelo": "IM",
    "busquedas": "23"
  },
  {
    "marca": "NISSAN",
    "modelo": "QASHQAI+2",
    "busquedas": "23"
  },
  {
    "marca": "GMC",
    "modelo": "SAFARI",
    "busquedas": "23"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "ASTRO",
    "busquedas": "22"
  },
  {
    "marca": "INFINITI",
    "modelo": "JX35",
    "busquedas": "22"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVEO5",
    "busquedas": "22"
  },
  {
    "marca": "BMW",
    "modelo": "318IS",
    "busquedas": "22"
  },
  {
    "marca": "MAZDA",
    "modelo": "MX-5 MIATA",
    "busquedas": "22"
  },
  {
    "marca": "KIA",
    "modelo": "CARNIVAL",
    "busquedas": "22"
  },
  {
    "marca": "SCION",
    "modelo": "FR-S",
    "busquedas": "21"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C280",
    "busquedas": "21"
  },
  {
    "marca": "FORD",
    "modelo": "FREESTAR",
    "busquedas": "21"
  },
  {
    "marca": "PONTIAC",
    "modelo": "GRAND PRIX",
    "busquedas": "21"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C350",
    "busquedas": "21"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO II",
    "busquedas": "21"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO",
    "busquedas": "20"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DISCOVERY SPORT",
    "busquedas": "20"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CORONA",
    "busquedas": "19"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "VOYAGER",
    "busquedas": "19"
  },
  {
    "marca": "FORD",
    "modelo": "FREESTYLE",
    "busquedas": "19"
  },
  {
    "marca": "RENAULT",
    "modelo": "KOLEOS",
    "busquedas": "19"
  },
  {
    "marca": "SUZUKI",
    "modelo": "IGNIS",
    "busquedas": "19"
  },
  {
    "marca": "GMC",
    "modelo": "JIMMY",
    "busquedas": "18"
  },
  {
    "marca": "LEXUS",
    "modelo": "LS400",
    "busquedas": "18"
  },
  {
    "marca": "RAM",
    "modelo": "1500 CLASSIC",
    "busquedas": "18"
  },
  {
    "marca": "INFINITI",
    "modelo": "G20",
    "busquedas": "18"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C1500",
    "busquedas": "18"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE KOUP",
    "busquedas": "18"
  },
  {
    "marca": "BMW",
    "modelo": "740I",
    "busquedas": "17"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 ECONOLINE",
    "busquedas": "17"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR2",
    "busquedas": "17"
  },
  {
    "marca": "VOLVO",
    "modelo": "S70",
    "busquedas": "17"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 1500",
    "busquedas": "17"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E400",
    "busquedas": "17"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "BREEZE",
    "busquedas": "17"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RAIZE",
    "busquedas": "17"
  },
  {
    "marca": "LEXUS",
    "modelo": "GS300",
    "busquedas": "16"
  },
  {
    "marca": "ZNA",
    "modelo": "RICH 6",
    "busquedas": "16"
  },
  {
    "marca": "JEEP",
    "modelo": "WRANGLER JK",
    "busquedas": "16"
  },
  {
    "marca": "JMC",
    "modelo": "PICK UP",
    "busquedas": "16"
  },
  {
    "marca": "BMW",
    "modelo": "335XI",
    "busquedas": "16"
  },
  {
    "marca": "FORD",
    "modelo": "FIGO",
    "busquedas": "16"
  },
  {
    "marca": "NISSAN",
    "modelo": "STANZA",
    "busquedas": "16"
  },
  {
    "marca": "BUICK",
    "modelo": "RENDEZVOUS",
    "busquedas": "15"
  },
  {
    "marca": "CADILLAC",
    "modelo": "ESCALADE ESV",
    "busquedas": "15"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL320",
    "busquedas": "15"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK350",
    "busquedas": "15"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 2500",
    "busquedas": "15"
  },
  {
    "marca": "ISUZU",
    "modelo": "AXIOM",
    "busquedas": "15"
  },
  {
    "marca": "KIA",
    "modelo": "PRIDE",
    "busquedas": "14"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "DAMAS/LABO",
    "busquedas": "14"
  },
  {
    "marca": "SUBARU",
    "modelo": "CROSSTREK",
    "busquedas": "14"
  },
  {
    "marca": "BMW",
    "modelo": "640I",
    "busquedas": "14"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "SAVEIRO",
    "busquedas": "14"
  },
  {
    "marca": "BMW",
    "modelo": "335I XDRIVE",
    "busquedas": "14"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 ECONOLINE CLUB WAGON",
    "busquedas": "14"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLA250",
    "busquedas": "14"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CROSSFOX",
    "busquedas": "13"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "AZERA",
    "busquedas": "13"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS350",
    "busquedas": "13"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "300D",
    "busquedas": "13"
  },
  {
    "marca": "FORD",
    "modelo": "MAVERICK",
    "busquedas": "13"
  },
  {
    "marca": "FORD",
    "modelo": "E-150 ECONOLINE",
    "busquedas": "13"
  },
  {
    "marca": "SUBARU",
    "modelo": "BRAT",
    "busquedas": "13"
  },
  {
    "marca": "SUZUKI",
    "modelo": "ERTIGA",
    "busquedas": "13"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK300",
    "busquedas": "13"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK230",
    "busquedas": "13"
  },
  {
    "marca": "DODGE",
    "modelo": "D350",
    "busquedas": "13"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR3",
    "busquedas": "12"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PASEO",
    "busquedas": "12"
  },
  {
    "marca": "AUDI",
    "modelo": "A3",
    "busquedas": "12"
  },
  {
    "marca": "SUBARU",
    "modelo": "BRZ",
    "busquedas": "12"
  },
  {
    "marca": "SCION",
    "modelo": "IA",
    "busquedas": "12"
  },
  {
    "marca": "PONTIAC",
    "modelo": "AZTEK",
    "busquedas": "12"
  },
  {
    "marca": "BMW",
    "modelo": "528I XDRIVE",
    "busquedas": "12"
  },
  {
    "marca": "BMW",
    "modelo": "530XI",
    "busquedas": "12"
  },
  {
    "marca": "BMW",
    "modelo": "540I",
    "busquedas": "12"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATHFINDER ARMADA",
    "busquedas": "12"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "XPANDER CROSS",
    "busquedas": "12"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS200",
    "busquedas": "12"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C1500 SUBURBAN",
    "busquedas": "12"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CMP",
    "busquedas": "12"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "K1500",
    "busquedas": "12"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "NOVA",
    "busquedas": "12"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "S10 BLAZER",
    "busquedas": "12"
  },
  {
    "marca": "VOLVO",
    "modelo": "C70",
    "busquedas": "12"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "ROUTAN",
    "busquedas": "12"
  },
  {
    "marca": "FORD",
    "modelo": "FESTIVA",
    "busquedas": "12"
  },
  {
    "marca": "RENAULT",
    "modelo": "KANGOO",
    "busquedas": "11"
  },
  {
    "marca": "PORSCHE",
    "modelo": "MACAN",
    "busquedas": "11"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "GRAND VOYAGER",
    "busquedas": "11"
  },
  {
    "marca": "CADILLAC",
    "modelo": "XT5",
    "busquedas": "11"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX450",
    "busquedas": "11"
  },
  {
    "marca": "HONDA",
    "modelo": "CRX",
    "busquedas": "11"
  },
  {
    "marca": "NISSAN",
    "modelo": "200SX",
    "busquedas": "11"
  },
  {
    "marca": "FORD",
    "modelo": "AEROSTAR",
    "busquedas": "11"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-50",
    "busquedas": "10"
  },
  {
    "marca": "MAZDA",
    "modelo": "MILLENIA",
    "busquedas": "10"
  },
  {
    "marca": "DODGE",
    "modelo": "RAIDER",
    "busquedas": "10"
  },
  {
    "marca": "MAZDA",
    "modelo": "RX-8",
    "busquedas": "10"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "KONA",
    "busquedas": "10"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER CLUBMAN",
    "busquedas": "10"
  },
  {
    "marca": "PONTIAC",
    "modelo": "GRAND AM",
    "busquedas": "10"
  },
  {
    "marca": "PORSCHE",
    "modelo": "PANAMERA",
    "busquedas": "10"
  },
  {
    "marca": "RENAULT",
    "modelo": "CLIO",
    "busquedas": "10"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "STARIA",
    "busquedas": "10"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "RABBIT",
    "busquedas": "10"
  },
  {
    "marca": "AUDI",
    "modelo": "A4 QUATTRO",
    "busquedas": "10"
  },
  {
    "marca": "SATURN",
    "modelo": "LS",
    "busquedas": "10"
  },
  {
    "marca": "AUDI",
    "modelo": "A6",
    "busquedas": "10"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LITE ACE",
    "busquedas": "10"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 LD",
    "busquedas": "10"
  },
  {
    "marca": "SATURN",
    "modelo": "OUTLOOK",
    "busquedas": "10"
  },
  {
    "marca": "SATURN",
    "modelo": "SC1",
    "busquedas": "10"
  },
  {
    "marca": "JMC",
    "modelo": "GRAND AVENUE",
    "busquedas": "9"
  },
  {
    "marca": "SUZUKI",
    "modelo": "DZIRE",
    "busquedas": "9"
  },
  {
    "marca": "FOTON",
    "modelo": "TUNLAND",
    "busquedas": "9"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK500",
    "busquedas": "9"
  },
  {
    "marca": "BMW",
    "modelo": "325ES",
    "busquedas": "9"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "UPLANDER",
    "busquedas": "9"
  },
  {
    "marca": "PORSCHE",
    "modelo": "911",
    "busquedas": "9"
  },
  {
    "marca": "BMW",
    "modelo": "M3",
    "busquedas": "9"
  },
  {
    "marca": "BUICK",
    "modelo": "LACROSSE",
    "busquedas": "9"
  },
  {
    "marca": "BMW",
    "modelo": "650I",
    "busquedas": "9"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR4",
    "busquedas": "9"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "K2500",
    "busquedas": "8"
  },
  {
    "marca": "KIA",
    "modelo": "MOHAVE",
    "busquedas": "8"
  },
  {
    "marca": "FORD",
    "modelo": "F-250 HD",
    "busquedas": "8"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GENESIS",
    "busquedas": "8"
  },
  {
    "marca": "BMW",
    "modelo": "318TI",
    "busquedas": "8"
  },
  {
    "marca": "BMW",
    "modelo": "325E",
    "busquedas": "8"
  },
  {
    "marca": "DODGE",
    "modelo": "SPRINTER 2500",
    "busquedas": "8"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S350",
    "busquedas": "8"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS V",
    "busquedas": "8"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MR2 SPYDER",
    "busquedas": "8"
  },
  {
    "marca": "MERCURY",
    "modelo": "COUGAR",
    "busquedas": "8"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA",
    "busquedas": "8"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 3500",
    "busquedas": "8"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MR2",
    "busquedas": "8"
  },
  {
    "marca": "BMW",
    "modelo": "328D XDRIVE",
    "busquedas": "8"
  },
  {
    "marca": "AUDI",
    "modelo": "A5 QUATTRO",
    "busquedas": "8"
  },
  {
    "marca": "KIA",
    "modelo": "AMANTI",
    "busquedas": "7"
  },
  {
    "marca": "DAEWOO",
    "modelo": "LEGANZA",
    "busquedas": "7"
  },
  {
    "marca": "DAEWOO",
    "modelo": "NUBIRA",
    "busquedas": "7"
  },
  {
    "marca": "LEXUS",
    "modelo": "NX300",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "328CI",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "428I",
    "busquedas": "7"
  },
  {
    "marca": "JMC",
    "modelo": "JX",
    "busquedas": "7"
  },
  {
    "marca": "JIM",
    "modelo": "REMAX",
    "busquedas": "7"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX400H",
    "busquedas": "7"
  },
  {
    "marca": "GMC",
    "modelo": "S15",
    "busquedas": "7"
  },
  {
    "marca": "FORD",
    "modelo": "E-250 ECONOLINE",
    "busquedas": "7"
  },
  {
    "marca": "JAGUAR",
    "modelo": "S-TYPE",
    "busquedas": "7"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLA250",
    "busquedas": "7"
  },
  {
    "marca": "FORD",
    "modelo": "E-150 ECONOLINE CLUB WAGON",
    "busquedas": "7"
  },
  {
    "marca": "FORD",
    "modelo": "FIVE HUNDRED",
    "busquedas": "7"
  },
  {
    "marca": "SUBARU",
    "modelo": "TRIBECA",
    "busquedas": "7"
  },
  {
    "marca": "SUBARU",
    "modelo": "GL",
    "busquedas": "7"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-370",
    "busquedas": "7"
  },
  {
    "marca": "SATURN",
    "modelo": "SW1",
    "busquedas": "7"
  },
  {
    "marca": "FIAT",
    "modelo": "SIENA",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "320I XDRIVE",
    "busquedas": "7"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER PHEV",
    "busquedas": "7"
  },
  {
    "marca": "NISSAN",
    "modelo": "300ZX",
    "busquedas": "7"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE XL",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "330I XDRIVE",
    "busquedas": "6"
  },
  {
    "marca": "JAC",
    "modelo": "T8 PRO",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK430",
    "busquedas": "6"
  },
  {
    "marca": "CHANGAN",
    "modelo": "CM10",
    "busquedas": "6"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C2500",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLS450",
    "busquedas": "6"
  },
  {
    "marca": "LEXUS",
    "modelo": "GS350",
    "busquedas": "6"
  },
  {
    "marca": "LEXUS",
    "modelo": "LS460",
    "busquedas": "6"
  },
  {
    "marca": "MASERATI",
    "modelo": "QUATTROPORTE",
    "busquedas": "6"
  },
  {
    "marca": "SATURN",
    "modelo": "LS1",
    "busquedas": "6"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "CROSSFIRE",
    "busquedas": "6"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CABRIO",
    "busquedas": "6"
  },
  {
    "marca": "RENAULT",
    "modelo": "CLIO II",
    "busquedas": "6"
  },
  {
    "marca": "INFINITI",
    "modelo": "EX35",
    "busquedas": "6"
  },
  {
    "marca": "BMW",
    "modelo": "325",
    "busquedas": "6"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "FOX",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK320",
    "busquedas": "6"
  },
  {
    "marca": "SUZUKI",
    "modelo": "EECO CARGO",
    "busquedas": "6"
  },
  {
    "marca": "TOYOTA",
    "modelo": "C-HR",
    "busquedas": "6"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C3500",
    "busquedas": "6"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK CLASSIC",
    "busquedas": "6"
  },
  {
    "marca": "SATURN",
    "modelo": "SKY",
    "busquedas": "5"
  },
  {
    "marca": "JAC",
    "modelo": "X200",
    "busquedas": "5"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AGYA",
    "busquedas": "5"
  },
  {
    "marca": "CHANGAN",
    "modelo": "CS15",
    "busquedas": "5"
  },
  {
    "marca": "VOLVO",
    "modelo": "V50",
    "busquedas": "5"
  },
  {
    "marca": "KIA",
    "modelo": "NIRO",
    "busquedas": "5"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 HD",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "300E",
    "busquedas": "5"
  },
  {
    "marca": "NISSAN",
    "modelo": "PULSAR NX",
    "busquedas": "5"
  },
  {
    "marca": "CHANGAN",
    "modelo": "HUNTER",
    "busquedas": "5"
  },
  {
    "marca": "JEEP",
    "modelo": "WAGONEER",
    "busquedas": "5"
  },
  {
    "marca": "JAGUAR",
    "modelo": "XF",
    "busquedas": "5"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 1500 VAN",
    "busquedas": "5"
  },
  {
    "marca": "ACURA",
    "modelo": "RL",
    "busquedas": "5"
  },
  {
    "marca": "RAM",
    "modelo": "DAKOTA",
    "busquedas": "5"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G3",
    "busquedas": "5"
  },
  {
    "marca": "BMW",
    "modelo": "750I",
    "busquedas": "5"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA CRUZ",
    "busquedas": "5"
  },
  {
    "marca": "FORD",
    "modelo": "TAURUS X",
    "busquedas": "5"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "DIAMANTE",
    "busquedas": "5"
  },
  {
    "marca": "AUDI",
    "modelo": "Q3",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK320",
    "busquedas": "5"
  },
  {
    "marca": "TOYOTA",
    "modelo": "GR86",
    "busquedas": "5"
  },
  {
    "marca": "DODGE",
    "modelo": "ATTITUDE",
    "busquedas": "5"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "EXPO",
    "busquedas": "5"
  },
  {
    "marca": "AUDI",
    "modelo": "TT QUATTRO",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL350",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL550",
    "busquedas": "5"
  },
  {
    "marca": "BMW",
    "modelo": "325IS",
    "busquedas": "5"
  },
  {
    "marca": "SUBARU",
    "modelo": "B9 TRIBECA",
    "busquedas": "5"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV3500",
    "busquedas": "5"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C2500 SUBURBAN",
    "busquedas": "5"
  },
  {
    "marca": "BMW",
    "modelo": "550I XDRIVE",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLE53 AMG",
    "busquedas": "5"
  },
  {
    "marca": "BMW",
    "modelo": "X7",
    "busquedas": "5"
  },
  {
    "marca": "JEEP",
    "modelo": "COMANCHE",
    "busquedas": "5"
  },
  {
    "marca": "NISSAN",
    "modelo": "KICKS PLAY",
    "busquedas": "5"
  },
  {
    "marca": "GMC",
    "modelo": "ENVOY XL",
    "busquedas": "4"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE5",
    "busquedas": "4"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DEFENDER",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "LUV",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MALIBU LIMITED",
    "busquedas": "4"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER VELAR",
    "busquedas": "4"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKZ",
    "busquedas": "4"
  },
  {
    "marca": "CADILLAC",
    "modelo": "XTS",
    "busquedas": "4"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC40",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK EV",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 3500 HD",
    "busquedas": "4"
  },
  {
    "marca": "BUICK",
    "modelo": "LUCERNE",
    "busquedas": "4"
  },
  {
    "marca": "JAC",
    "modelo": "T6",
    "busquedas": "4"
  },
  {
    "marca": "JAC",
    "modelo": "PICKUP",
    "busquedas": "4"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLE350",
    "busquedas": "4"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLE450",
    "busquedas": "4"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "ASPEN",
    "busquedas": "4"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S320",
    "busquedas": "4"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q50",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "M2",
    "busquedas": "4"
  },
  {
    "marca": "NISSAN",
    "modelo": "210",
    "busquedas": "4"
  },
  {
    "marca": "NISSAN",
    "modelo": "CIVILIAN",
    "busquedas": "4"
  },
  {
    "marca": "NISSAN",
    "modelo": "NX",
    "busquedas": "4"
  },
  {
    "marca": "DAIHATSU",
    "modelo": "CHARADE",
    "busquedas": "4"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRAND I10 HB",
    "busquedas": "4"
  },
  {
    "marca": "DODGE",
    "modelo": "B1500",
    "busquedas": "4"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "T-CROSS",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "335D",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "228I",
    "busquedas": "4"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER 2500",
    "busquedas": "4"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER 3500",
    "busquedas": "4"
  },
  {
    "marca": "SUBARU",
    "modelo": "DL",
    "busquedas": "4"
  },
  {
    "marca": "SUBARU",
    "modelo": "JUSTY",
    "busquedas": "4"
  },
  {
    "marca": "SUBARU",
    "modelo": "LOYALE",
    "busquedas": "4"
  },
  {
    "marca": "SUBARU",
    "modelo": "WRX",
    "busquedas": "4"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 2500 VAN",
    "busquedas": "4"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 3500 HD",
    "busquedas": "4"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 1500 LIMITED",
    "busquedas": "4"
  },
  {
    "marca": "AUDI",
    "modelo": "A6 QUATTRO",
    "busquedas": "4"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "BORA",
    "busquedas": "4"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT",
    "busquedas": "4"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "NIVUS",
    "busquedas": "4"
  },
  {
    "marca": "PORSCHE",
    "modelo": "CAYMAN",
    "busquedas": "3"
  },
  {
    "marca": "DAEWOO",
    "modelo": "MATIZ",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK280",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "228I GRAN COUPE",
    "busquedas": "3"
  },
  {
    "marca": "INFINITI",
    "modelo": "M35",
    "busquedas": "3"
  },
  {
    "marca": "SAAB",
    "modelo": "9-3",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S550",
    "busquedas": "3"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX50",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S430",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML550",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML430",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLC300",
    "busquedas": "3"
  },
  {
    "marca": "GMC",
    "modelo": "YUKON XL 2500",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E550",
    "busquedas": "3"
  },
  {
    "marca": "FORD",
    "modelo": "CROWN VICTORIA",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MONTE CARLO",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK350",
    "busquedas": "3"
  },
  {
    "marca": "LEXUS",
    "modelo": "ES350",
    "busquedas": "3"
  },
  {
    "marca": "SUZUKI",
    "modelo": "LIANA",
    "busquedas": "3"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 3500",
    "busquedas": "3"
  },
  {
    "marca": "SUZUKI",
    "modelo": "VERONA",
    "busquedas": "3"
  },
  {
    "marca": "DODGE",
    "modelo": "SPRINTER 3500",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORSA",
    "busquedas": "3"
  },
  {
    "marca": "JEEP",
    "modelo": "CJ7",
    "busquedas": "3"
  },
  {
    "marca": "MAZDA",
    "modelo": "MX-5",
    "busquedas": "3"
  },
  {
    "marca": "MAZDA",
    "modelo": "929",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500 HD CLASSIC",
    "busquedas": "3"
  },
  {
    "marca": "ACURA",
    "modelo": "CL",
    "busquedas": "3"
  },
  {
    "marca": "JEEP",
    "modelo": "GRAND CHEROKEE L",
    "busquedas": "3"
  },
  {
    "marca": "LINCOLN",
    "modelo": "LS",
    "busquedas": "3"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX450H",
    "busquedas": "3"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX350L",
    "busquedas": "3"
  },
  {
    "marca": "VOLVO",
    "modelo": "V40",
    "busquedas": "3"
  },
  {
    "marca": "CHERY",
    "modelo": "TIGGO 4 PRO",
    "busquedas": "3"
  },
  {
    "marca": "PONTIAC",
    "modelo": "FIERO",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "335IS",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "550I",
    "busquedas": "3"
  },
  {
    "marca": "GMC",
    "modelo": "SYCLONE",
    "busquedas": "2"
  },
  {
    "marca": "JAGUAR",
    "modelo": "F-TYPE",
    "busquedas": "2"
  },
  {
    "marca": "SUZUKI",
    "modelo": "CIAZ",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAVERSE LIMITED",
    "busquedas": "2"
  },
  {
    "marca": "KIA",
    "modelo": "TOWNER",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "TERRITORY",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAILBLAZER EXT",
    "busquedas": "2"
  },
  {
    "marca": "AUDI",
    "modelo": "S5",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "TEMPO",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CL500",
    "busquedas": "2"
  },
  {
    "marca": "AUDI",
    "modelo": "RS4",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "C-MAX",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOL",
    "busquedas": "2"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "306",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C200",
    "busquedas": "2"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "206",
    "busquedas": "2"
  },
  {
    "marca": "TESLA",
    "modelo": "S",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "635CSI",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "300SDL",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 1500 CLASSIC",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "190D",
    "busquedas": "2"
  },
  {
    "marca": "PONTIAC",
    "modelo": "FIREBIRD",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "VAN",
    "busquedas": "2"
  },
  {
    "marca": "MAZDA",
    "modelo": "E2200",
    "busquedas": "2"
  },
  {
    "marca": "TOYOTA",
    "modelo": "ETIOS",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "TSURU",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "535D XDRIVE",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "645CI",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "G20",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "750LI",
    "busquedas": "2"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "CORDIA",
    "busquedas": "2"
  },
  {
    "marca": "MERCURY",
    "modelo": "TOPAZ",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK55 AMG",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "545I",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SL550",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "M5",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "340I XDRIVE",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOLF R",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 CLASSIC",
    "busquedas": "2"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER 1500",
    "busquedas": "2"
  },
  {
    "marca": "KIA",
    "modelo": "K3",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "PASSAT CC",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TRANSPORTER",
    "busquedas": "2"
  },
  {
    "marca": "INFINITI",
    "modelo": "M45",
    "busquedas": "2"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q60",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CABRIOLET",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "AURA",
    "busquedas": "2"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q70L",
    "busquedas": "2"
  },
  {
    "marca": "AUDI",
    "modelo": "A5",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "F-150 HERITAGE",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S500",
    "busquedas": "2"
  },
  {
    "marca": "EAGLE",
    "modelo": "TALON",
    "busquedas": "2"
  },
  {
    "marca": "LINCOLN",
    "modelo": "CONTINENTAL",
    "busquedas": "2"
  },
  {
    "marca": "PONTIAC",
    "modelo": "MONTANA",
    "busquedas": "2"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS200T",
    "busquedas": "2"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX550",
    "busquedas": "2"
  },
  {
    "marca": "ISUZU",
    "modelo": "IMPULSE",
    "busquedas": "2"
  },
  {
    "marca": "AUDI",
    "modelo": "A3 QUATTRO",
    "busquedas": "2"
  },
  {
    "marca": "FIAT",
    "modelo": "BRAVA",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "R20 SUBURBAN",
    "busquedas": "2"
  },
  {
    "marca": "DATSUN",
    "modelo": "PICKUP",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E55 AMG",
    "busquedas": "2"
  },
  {
    "marca": "CHERY",
    "modelo": "TIGGO 2 PRO",
    "busquedas": "2"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "PRECIS",
    "busquedas": "1"
  },
  {
    "marca": "ACURA",
    "modelo": "ZDX",
    "busquedas": "1"
  },
  {
    "marca": "ASTON MARTIN",
    "modelo": "DBS",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "90 QUATTRO",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "A7",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "228I XDRIVE",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "230I XDRIVE",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "430I",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "525IT",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "535I GT",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "535I XDRIVE",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "740IL",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "I8",
    "busquedas": "1"
  },
  {
    "marca": "BUGATTI",
    "modelo": "CHIRON",
    "busquedas": "1"
  },
  {
    "marca": "CADILLAC",
    "modelo": "CATERA",
    "busquedas": "1"
  },
  {
    "marca": "CADILLAC",
    "modelo": "DTS",
    "busquedas": "1"
  },
  {
    "marca": "CHANGAN",
    "modelo": "CS35 PLUS",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C10 SUBURBAN",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORSICA",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS PASAJEROS",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "LANOS",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "LUMINA",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MATIZ",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SONORA",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "V1500 SUBURBAN",
    "busquedas": "1"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "GRAND VOYAGER",
    "busquedas": "1"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PACIFICA",
    "busquedas": "1"
  },
  {
    "marca": "CODA",
    "modelo": "SEDAN",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "B250",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "D100",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "D250",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "RAMCHARGER",
    "busquedas": "1"
  },
  {
    "marca": "FIAT",
    "modelo": "124 SPIDER",
    "busquedas": "1"
  },
  {
    "marca": "FIAT",
    "modelo": "500X",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "ASPIRE",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "E-250 ECONOLINE CLUB WAGON",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 CLUB WAGON",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "FIESTA IKON",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "GRANADA",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "THUNDERBIRD",
    "busquedas": "1"
  },
  {
    "marca": "FOTON",
    "modelo": "VIEW CS2",
    "busquedas": "1"
  },
  {
    "marca": "GMC",
    "modelo": "C1500 SUBURBAN",
    "busquedas": "1"
  },
  {
    "marca": "GMC",
    "modelo": "K1500",
    "busquedas": "1"
  },
  {
    "marca": "HONDA",
    "modelo": "ACCORD CROSSTOUR",
    "busquedas": "1"
  },
  {
    "marca": "HONDA",
    "modelo": "CLARITY",
    "busquedas": "1"
  },
  {
    "marca": "HUMMER",
    "modelo": "H1",
    "busquedas": "1"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "AVANTE",
    "busquedas": "1"
  },
  {
    "marca": "INFINITI",
    "modelo": "FX45",
    "busquedas": "1"
  },
  {
    "marca": "INFINITI",
    "modelo": "I30",
    "busquedas": "1"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q40",
    "busquedas": "1"
  },
  {
    "marca": "ISUZU",
    "modelo": "ASCENDER",
    "busquedas": "1"
  },
  {
    "marca": "JAC",
    "modelo": "JS2",
    "busquedas": "1"
  },
  {
    "marca": "JAGUAR",
    "modelo": "F-PACE",
    "busquedas": "1"
  },
  {
    "marca": "JAGUAR",
    "modelo": "XE",
    "busquedas": "1"
  },
  {
    "marca": "JMC",
    "modelo": "MINIBUS",
    "busquedas": "1"
  },
  {
    "marca": "KIA",
    "modelo": "GRAND CARNIVAL",
    "busquedas": "1"
  },
  {
    "marca": "LAMBORGHINI",
    "modelo": "MURCIELAGO",
    "busquedas": "1"
  },
  {
    "marca": "LEXUS",
    "modelo": "NX250",
    "busquedas": "1"
  },
  {
    "marca": "LEXUS",
    "modelo": "SC430",
    "busquedas": "1"
  },
  {
    "marca": "MAXUS",
    "modelo": "D90",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-70",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-90",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "NAVAJO",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "300CD",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "500SEL",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C43 AMG",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C450 AMG",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK550",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "G63 AMG",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLB250",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLS350D",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML63 AMG",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SPRINTER",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SPRINTER 2500",
    "busquedas": "1"
  },
  {
    "marca": "MERCURY",
    "modelo": "CAPRI",
    "busquedas": "1"
  },
  {
    "marca": "MERCURY",
    "modelo": "MILAN",
    "busquedas": "1"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "3008",
    "busquedas": "1"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER CITY",
    "busquedas": "1"
  },
  {
    "marca": "RENAULT",
    "modelo": "SCENIC",
    "busquedas": "1"
  },
  {
    "marca": "SATURN",
    "modelo": "L200",
    "busquedas": "1"
  },
  {
    "marca": "SATURN",
    "modelo": "L300",
    "busquedas": "1"
  },
  {
    "marca": "SATURN",
    "modelo": "SW2",
    "busquedas": "1"
  },
  {
    "marca": "SMART",
    "modelo": "FORTWO",
    "busquedas": "1"
  },
  {
    "marca": "SSANGYONG",
    "modelo": "KORANDO",
    "busquedas": "1"
  },
  {
    "marca": "SUBARU",
    "modelo": "STANDARD",
    "busquedas": "1"
  },
  {
    "marca": "SUZUKI",
    "modelo": "KIZASHI",
    "busquedas": "1"
  },
  {
    "marca": "SUZUKI",
    "modelo": "S-CROSS",
    "busquedas": "1"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SJ410",
    "busquedas": "1"
  },
  {
    "marca": "TESLA",
    "modelo": "3",
    "busquedas": "1"
  },
  {
    "marca": "TESLA",
    "modelo": "Y",
    "busquedas": "1"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS C",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CRAFTER",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "EOS",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOLF SPORTWAGEN",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "R32",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "VIRTUS",
    "busquedas": "1"
  },
  {
    "marca": "VOLVO",
    "modelo": "V40 CROSS COUNTRY",
    "busquedas": "1"
  }
];

export default preloadedVehiclesModels;
